/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_LocalityInputs */

const cs_filter_locality = /** @type {(inputs: Filter_LocalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lokalita`)
};

const en_filter_locality = /** @type {(inputs: Filter_LocalityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Locality`)
};

/**
* | output |
* | --- |
* | "Locality" |
*
* @param {Filter_LocalityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const filter_locality = /** @type {((inputs?: Filter_LocalityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_LocalityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filter_locality(inputs)
	return cs_filter_locality(inputs)
});